import { useState, type FormEvent } from 'react';
import { useLogin } from '@/hooks/api';
import { Spinner } from '@/components/ui';

export function LoginPage() {
  const [password, setPassword] = useState('');
  const login = useLogin();

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!password || login.isPending) return;
    login.mutate(password);
  };

  return (
    <main className="flex min-h-screen items-center justify-center px-4">
      <div className="card w-full max-w-sm p-8">
        <div className="mb-6 text-center">
          <h1 className="text-xl font-semibold tracking-tight">Otakotakdev</h1>
          <p className="mt-1 text-sm text-muted">Your second brain</p>
        </div>

        <form onSubmit={onSubmit} noValidate>
          <div className="mb-4">
            <label htmlFor="password" className="label">
              Password
            </label>
            <input
              id="password"
              name="password"
              type="password"
              className="input"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              aria-invalid={login.isError}
              aria-describedby={login.isError ? 'login-error' : undefined}
            />
          </div>

          {login.isError && (
            <p id="login-error" role="alert" className="mb-4 text-sm text-danger">
              {login.error instanceof Error ? login.error.message : 'Invalid password'}
            </p>
          )}

          <button type="submit" className="btn-primary w-full" disabled={login.isPending || !password}>
            {login.isPending ? <Spinner label="Signing in…" /> : 'Sign in'}
          </button>
        </form>
      </div>
    </main>
  );
}
